<template>
  <div class="container">
    <div class="grid">
      <div class="custom">
        <div class="image flex-col">
          <img src="@/assets/zippo4.webp" alt="custom design lighter image" />
        </div>
        <h4>Custom Lighters</h4>
      </div>
      <div class="mockup">
        <div class="image flex-col">
          <img src="@/assets/WEBSITE10.webp" alt="T-Shirt mockup image" />
        </div>
        <h4>T-shirt Mockup</h4>
      </div>
      <div class="pattern">
        <div class="image flex-col">
          <img src="@/assets/WEBSITE9.webp" alt="custom patterns image" />
        </div>
        <h4>T-shirt Patterns</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
  text-align: center;
  text-transform: uppercase;
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 1rem 2rem;
  transition: all 0.25s ease-in-out;
}

.grid {
  /* padding: 1rem; */
  display: grid;
  text-align: center;
  gap: 30px;
  position: relative;
  grid-template-columns: repeat(1, 1fr);
  transition: all 0.25s ease-in-out;
}

.flex-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom,
.pattern,
.mockup {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.custom img {
  max-width: 60%;
}

* > img {
  margin-bottom: 1rem;
  width: 75%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  /* 5px 6px 5px 1px */
  filter: drop-shadow(6px 6px 4px rgba(0, 0, 0, 0.589));
  /* filter: drop-shadow(10px 10px 8px rgba(0, 0, 0, 0.589)); */
}
/*=========================================== MEDIA=========================================================== */

@media screen and (min-width: 500px) {
  .grid {
    gap: 20px;
    grid-template-columns: repeat(3, 1fr);
  }
  * > h4 {
    transition: all 0.25s ease-in-out;
    font-size: 0.9rem;
  }
}
@media screen and (min-width: 768px) {
  * > h4 {
    font-size: 1.1rem;
    transition: all 0.25s ease-in-out;
  }
}
</style>